<rav-modal modalId="authenticator-2fa" modalTitle="Authenticator App Setup">
  <div *ngIf="modalData" class="padding-top-2">
    <ol>
      <li>Search for "authenticator" in your app store.</li>
      <li>Open the app</li>
      <li>Pair the app with your Raven Account by scanning this QR code or by entering the number manually:</li>
      <div>
        <img src="{{ modalData['qr_data'] }}" />
        <h3>{{ modalData['secret'] }}</h3>
      </div>
      <li>Verify your authenticator app by entering the provided security code below:</li>
      <div [class.form__error-msg]="errorMessage">
        <input
          type="tel"
          class="padding-horizontal-1"
          [class.is-invalid-input]="errorMessage"
          placeholder="Enter the 6 digit code"
          [(ngModel)]="code"
          (keyup.enter)="code && verifyCode()"
        />
        {{ errorMessage }}
      </div>
    </ol>

    <div class="margin-top-1">
      <button type="button" data-cy="cancel-button" (click)="closeModal()" class="hollow button margin-right-1">
        Cancel
      </button>
      <button type="button" (click)="verifyCode()" [disabled]="!code" class="button margin-right-1">Done</button>
    </div>
  </div>
</rav-modal>
